import AppRoutes from "AppRoutes";
import { SbbPersona } from "components/Persona/SbbPersona";
import { UserStatusEnum } from "enums/UserStatusEnum";
import { getAnonymizedAwareDisplayName } from "helpers";
import { UserLookupModel } from "models/UserLookupModel";
import { UserModel } from "models/UserModel";
import { useTranslations } from "providers";
import React from "react";

export interface DisplayUserProps {
  value?: UserModel | UserLookupModel;
  size?: number;
  title?: string;
  subTitle?: string;
  disabled?: boolean;
  showUrl?: boolean;
  showTitleWithOrganisationUnit?: boolean;
  showTitle?: boolean;
  showSubTitle?: boolean;
  addStatusClasses?: boolean;
  highlight?: string;
}

export const DisplayUser: React.FC<DisplayUserProps> = ({
  value,
  size,
  title,
  subTitle,
  disabled,
  showUrl = true,
  showTitle = true,
  showSubTitle = false,
  showTitleWithOrganisationUnit = false,
  addStatusClasses,
  highlight,
}) => {
  const i18n = useTranslations();
  if (!value) {
    return <span className="text-muted">-</span>;
  }

  const {
    personnelNumber,
    profileImage,
    initials,
    initialsColor,
    displayName,
    displayNameWithOrganisationUnit,
    status,
  } = value;

  const rawTitle = !title
    ? showTitleWithOrganisationUnit
      ? `${displayNameWithOrganisationUnit || ""}`
      : `${displayName || ""}`
    : title;
  const titleToUse = getAnonymizedAwareDisplayName(rawTitle, i18n);

  const subTitleToUse = subTitle ? subTitle : `${value.organisationUnit || ""}`;

  let classNames = "";
  if (addStatusClasses !== false && status !== undefined) {
    switch (status) {
      case UserStatusEnum.Unknown:
        classNames += "user-status-unknown";
        break;
      case UserStatusEnum.Deleted:
        classNames += "user-status-deleted";
        break;
      case UserStatusEnum.Enabled:
        // No special styling for enabled users
        break;
    }
  }

  const url = showUrl ? AppRoutes.toBackendUserDetail(personnelNumber) : undefined;

  let tooltip = getAnonymizedAwareDisplayName(displayNameWithOrganisationUnit, i18n);
  if (!tooltip.includes(titleToUse)) {
    tooltip += `\n${titleToUse}`;
  }
  if (!tooltip.includes(subTitleToUse)) {
    tooltip += `\n${subTitleToUse}`;
  }

  return (
    <>
      <SbbPersona
        url={url}
        disabled={disabled}
        title={showTitle ? titleToUse : undefined}
        subTitle={showSubTitle ? subTitleToUse : undefined}
        initials={initials}
        initialsColor={initialsColor}
        profileImage={profileImage}
        personnelNumber={personnelNumber}
        size={size}
        className={classNames}
        highlight={highlight}
        tooltip={tooltip}
      />
      {classNames.includes("user-status-deleted") && (
        <span
          className="ms-1 text-danger global-tooltip-trigger"
          title={`${i18n.User_Status} ${i18n.UserStatus_Deleted}`}
        >
          <i className="ms-Icon ms-Icon--AlertSolid me-1" />
        </span>
      )}
    </>
  );
};
